import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
  Badge,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import axios from "axios";
import { API_MAI_FALI } from "../utils";
import { logoutUser } from "../actions/AuthAction";

function getQueryParams(search) {
  const params = new URLSearchParams(search);
  return {
    desa: params.get("desa"),
    tahun: params.get("tahun"),
  };
}

const RekomendasiDetail = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { desa, tahun } = getQueryParams(location.search);
  const [loading, setLoading] = useState(false);
  const [rekomendasiData, setRekomendasiData] = useState(null);
  const [currentUser, setCurrentUser] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setCurrentUser(user);
    } else {
      logoutUser(props.history);
    }
  }, [props.history]);
  useEffect(() => {
    if (!desa || !tahun) {
      history.push("/admin/datastunting");
      return;
    }
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_MAI_FALI}indikator/data-perdesa-rekomendasi?tahun=${tahun}&idDesa=1`
        );
        if (response.data.success === 1 && response.data.data.length > 0) {
          const matchingData = response.data.data.find(
            (item) => item.desa.toLowerCase() === desa.toLowerCase()
          );
          setRekomendasiData(matchingData || response.data.data[0]);
        } else {
          setRekomendasiData(null);
        }
      } catch (error) {
        setRekomendasiData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [desa, tahun, history]);

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Rekomendasi Kebijakan</CardTitle>
              <Button color="secondary" onClick={() => history.goBack()}>
                Kembali
              </Button>
            </CardHeader>
            <CardBody>
              {loading ? (
                <div className="text-center py-4">
                  <p>Loading rekomendasi...</p>
                </div>
              ) : rekomendasiData ? (
                <div>
                  <div className="mb-3">
                    <h5>Informasi Desa</h5>
                    <Row>
                      <Col md="6">
                        <strong>Desa:</strong> {rekomendasiData.desa}
                      </Col>
                      <Col md="6">
                        <strong>Kecamatan:</strong> {rekomendasiData.kecamatan}
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md="6">
                        <strong>Tahun:</strong> {rekomendasiData.tahun}
                      </Col>
                      <Col md="6">
                        <strong>Total Rekomendasi:</strong>{" "}
                        {rekomendasiData.rekomendasi?.length || 0}
                      </Col>
                    </Row>
                  </div>
                  <hr />
                  <h5>Detail Rekomendasi per Indikator</h5>
                  {rekomendasiData.rekomendasi &&
                  rekomendasiData.rekomendasi.length > 0 ? (
                    <div>
                      {rekomendasiData.rekomendasi.map((rec, index) => (
                        <Card key={index} className="mb-3 border-left-primary">
                          <CardBody>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <h6 className="card-title mb-0 text-primary">
                                Indikator {index + 1}
                              </h6>
                              <Badge color="warning" className="ml-2">
                                Nilai: {rec.nilai}%
                              </Badge>
                            </div>
                            <p
                              className="text-muted mb-3"
                              style={{ fontSize: "0.9rem" }}
                            >
                              {rec.indikator}
                            </p>
                            <div>
                              <h6 className="text-success mb-2">
                                <i className="nc-icon nc-chart-pie-35 mr-1"></i>
                                Sub Kegiatan yang Direkomendasikan:
                              </h6>
                              <ListGroup>
                                {rec.sub_kegiatan &&
                                rec.sub_kegiatan.length > 0 ? (
                                  rec.sub_kegiatan.map(
                                    (subKegiatan, subIndex) => (
                                      <ListGroupItem
                                        key={subIndex}
                                        className="border-0 py-2"
                                      >
                                        <div className="d-flex align-items-start">
                                          <span className="badge badge-primary badge-pill mr-2 mt-1">
                                            {subIndex + 1}
                                          </span>
                                          <span style={{ fontSize: "0.9rem" }}>
                                            {subKegiatan}
                                          </span>
                                        </div>
                                      </ListGroupItem>
                                    )
                                  )
                                ) : (
                                  <ListGroupItem className="text-muted">
                                    Tidak ada sub kegiatan yang tersedia
                                  </ListGroupItem>
                                )}
                              </ListGroup>
                            </div>
                          </CardBody>
                        </Card>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <i
                        className="nc-icon nc-chart-pie-35 text-muted"
                        style={{ fontSize: "3rem" }}
                      ></i>
                      <p className="text-muted mt-2">
                        Tidak ada rekomendasi yang tersedia untuk desa ini
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-center py-4">
                  <i
                    className="nc-icon nc-chart-pie-35 text-danger"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <p className="text-danger mt-2">
                    Gagal memuat data rekomendasi
                  </p>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RekomendasiDetail;
